<template>
  <div class="tab_a">
    <div>
      <el-checkbox-group v-model="checkList" @change="ChanegeCheckGroup">
        <el-checkbox label="1">全选小童上装</el-checkbox>
        <el-checkbox label="2">全选小童下装</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="Size_box">
      <table border="0" cellspacing="0" class="hcp_table">
        <thead>
          <tr>
            <th>身高(cm)</th>
            <th>上装</th>
            <th>下装</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(item,key,index) in DataList" :key="index">
          <td>{{key}}</td>
          <td>
            <table border="0" cellspacing="0" class="hcp_table_child">
              <tr>
                <td v-for="(x,ind) in item.UP" :key="ind" @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x)}">
                  {{x.typeValue}}
                </td>
              </tr>
            </table>
          </td>
          <td>
            <table border="0"  cellspacing="0" class="hcp_table_child" >
              <tr>
                <td v-for="(x,ind) in item.DOWN" :key="ind" @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x)}">
                  {{x.typeValue}}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        </tbody>

      </table>
    </div>
    <div class="size_remake">
      <p class="tit">备注说明：</p>
      <p>1、上装：通常指腰以上服装，比如衬衫、羽绒服，上装110/52：110代表身高110cm，52代表胸围52cm。</p>
      <p>2、下装：通常指腰以下服装，比如裤子、裙子，下装110/50：110代表身高110cm，50代表腰围50cm。</p>
      <p>3、130cm及以下身高的不区分男女型号。</p>
    </div>
  </div>
</template>

<script>
import SizeMixins from './mixin'
export default {
  name: "ChildSize",
  mixins:[SizeMixins],
  props:{
    DataList:{
      type: Object,
      default: ()=>{}
    },
  },
  data(){
    return {
    }
  },
  mounted() {
    this.EchoSizeData('ChildSize')
  },
  created() {
  },
  methods:{
    ChangeSize(x){
      if(x.typeId) {
        this.StorageSizeData(x, 'ChildSize')
      }
    },
    ChanegeCheckGroup(val){
      this.SelectAllSizeTab(val,'ChildSize')
    }
  }
}
</script>

<style scoped lang="scss">
table {
  border: none;
  padding: 0;
  margin:0;
}
table thead th{
  font-size: 14px;
}
tr,td,p{
  padding: 0;
  margin:0;
}
.Size_box{
  margin-top: 10px;
  margin-bottom: 20px;
  width: 850px;
  .hcp_table{
    border-spacing: 0;
    border-top: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    background:rgb(246,246,246);
    thead{
      width: calc(100% - 17px);
    }
    tbody tr:last-child{
      border-bottom: none;
    }
    tr{
      background: #FFFFFF;
    }
    th{
      background: #F6F6F6;
    }
    td{
      cursor: pointer;
      font-size: 14px;
    }
    th,td{
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      text-align: center;
      min-width: 120px;
      height: 45px;
    }
    .hcp_table_child .active_size{
      background-color: #FAECE6;
      color: #000000;
    }
    .hcp_table_child td{
      border-bottom: none;
      width: 120px;
      cursor: pointer;
    }
    .hcp_table_child td:last-child{
      border-right: none;
    }
  }
}
.size_remake{
  font-size: 14px;
  color: #333333;
  .tit{
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
}


</style>